/**
 * Wistia codes for the ZBPortal introduction videos that auto-play on an administrator's first visit.
 *
 * Shared by the overview pages and the Help dropdown so both play the same video.
 */
export const zbAdminIntroVideoCodes = {
  districtAdmin: 'uf9aco3wsq',
  schoolAdmin: 'c16sftvnvp',
} as const;
